import styles from "../styles/Home.module.css";
import Header from "../local_components/Header";
import BackToTop from "../components/BackToTopButton";
import Footer from "../local_components/Footer";
import {
  useStoryblokState,
  getStoryblokApi,
  StoryblokComponent,
} from "@storyblok/react";

export default function Home({ story }) {
  story = useStoryblokState(story, { customParent: "http://localhost:3000/" });

  return (
    <div className={styles.container}>
      <Header />
      <StoryblokComponent blok={story.content} />
      <Footer />
      <BackToTop />
    </div>
  );
}

export async function getStaticProps() {
  let slug = "home";
  let slug2 = "marken-und-biere"

  let sbParams = {
    version: process.env.IS_PROD ? "published" : "draft"
  };

  const storyblokApi = getStoryblokApi();
  let { data } = await storyblokApi.get(`cdn/stories/${slug}`, sbParams);
  let { data2 } = await storyblokApi.get(`cdn/stories/${slug2}`, sbParams);

  return {
    props: {
      story: data ? data.story : false,
      key: data ? data.story.id : false,
    },
  };
}
